<template>
    <div>

        <div v-if="loadingFrequencia" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>

            <table class="table table-striped table-frequencia">
                <thead>
                    <tr>
                        <th class="u-text-center"></th>
                        <th 
                            :colspan="item" 
                            class="u-text-center"
                            v-for="(item, i) in frequencia['qtd_max_horario']"
                            :key="i+Math.random()"
                        >
                            {{ $CONSTANTS.NOME_MES(i) }}
                        </th>
                    </tr>
                </thead>
                <thead>                    
                    <tr>
                        <td class="u-text-center">DIA</td>
                        <template v-for="item in frequencia['qtd_max_horario']">
                            <td 
                                class="u-text-center"
                                v-for="(qtd, j) in item"
                                :key="j+Math.random()"
                            >
                                {{ item > 1 ? (j+1)+'º' : 'Frequência' }}
                            </td>
                        </template>
                    </tr>
                </thead>
                <tbody>

                    <tr v-for="(dia, id) in frequencia['chamada']" :key="id+Math.random()">

                        <td class="u-text-center">{{ id }}</td>
                        <template v-for="(mes, ii) in dia">
                            <template v-if="mes.length > 0">
                                <td v-for="(horario, ih) in mes" @click="selectHorario(ih, ii, id)" :key="(id+'1'+ih+Math.random())" class="u-text-center u-pointer" :class="{ 'hour-selected': horariosSelecionados[`${ih}-${id}-${ii}`] }">
                                    <span v-if="horario['d'] == 'f1' && horario['v'] == 'f'">f</span>
                                    <span v-else-if="horario['v'] == 'f'">{{ horario['d'] }}</span>
                                    <span v-else-if="horario['v'] == 'p'">
                                        <i class="u-fs-7 fas fa-circle"></i>
                                    </span>
                                    <span v-else-if="horario['v'] == 'er'">ER</span>
                                    <span v-else>{{ horario['v'] }}</span>
                                </td>
                                <td title="Dia não computado" v-for="(qtd, ic) in (frequencia['qtd_max_horario'][ii] - mes.length)" :key="(id+'2'+ic+Math.random())" class="u-text-center">
                                    -
                                </td>
                            </template>
                            <template v-else>
                                <td v-for="(qtd, ie) in frequencia['qtd_max_horario'][ii]" :key="(id+'3'+ie+Math.random())" class="u-text-center">
                                    -
                                </td>
                            </template>
                        </template>

                    </tr>
                    
                </tbody>
                <tfoot>
                    <tr>
                        <td class="u-text-center"><strong>Total Faltas</strong></td>

                        <template v-for="(qtdHorariosMes, mesIndex) in frequencia['qtd_max_horario']">
                            <td 
                                class="u-text-center"
                                :colspan="qtdHorariosMes"
                                :key="'faltas-'+mesIndex"
                            >
                                {{ getTotalFaltasMes(mesIndex) }}
                            </td>
                        </template>
                    </tr>

                    <tr>
                        <td class="u-text-center"><strong>% Frequência</strong></td>

                        <template v-for="(qtdHorariosMes, mesIndex) in frequencia['qtd_max_horario']">
                            <td 
                                class="u-text-center"
                                :colspan="qtdHorariosMes"
                                :key="'freq-'+mesIndex"
                            >
                                {{ getPercentualFrequenciaMes(mesIndex) }}%
                            </td>
                        </template>
                    </tr>
                </tfoot>
            </table>
            <el-row :gutter="10" v-if="mostra_gerenciar_freq && $store.state.user.tipo != 7"> 
                <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                    <el-button @click="openModalGerenciarFrequencia()" plain style="margin-top: 21px;">
                        GERENCIAR FREQUÊNCIA
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <el-dialog :close-on-click-modal="false" title="GERENCIAR FREQUÊNCIA" :visible.sync="dialogGerenciarFrequencia" append-to-body>
            <div v-if="dialogGerenciarFrequencia" style="margin-top: 20px;">
                <el-form @submit.native.prevent="onSubmitFormFaltaJustificada()" :model="gerenciarFrequencia" ref="gerenciarFrequencia" label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Ação" prop="acao" :rules="[$requiredChange]" key="acao">
                                <el-select v-model="gerenciarFrequencia.acao">
                                    <el-option key="fj" label="JUSTIFICAR FALTA" value="fj"></el-option>
                                    <el-option key="er" label="ENSINO REMOTO" value="er"></el-option>
                                    <!-- <el-option key="f" label="LANÇAR FALTA" value="f"></el-option>
                                    <el-option key="p" label="LANÇAR PRESENÇA" value="p"></el-option> -->
                                    <el-option v-if="$store.state.user.tipo == 6" key="empty" label="REMOVER REGISTROS" value="empty"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="gerenciarFrequencia.acao == 'fj'">                    
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Observação" prop="observacao" :rules="[$requiredBlur]" key="observacao">
                                <el-input :rows="5" type="textarea" v-model="gerenciarFrequencia.observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10"> 
                        <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue'

export default {
    props: ['id', 'turma_id', 'aluno_id', 'tipo_ensino', 'mostra_gerenciar_freq'],
    data: () => ({
        dialogGerenciarFrequencia: false,
        frequencia: {},
        loadingFrequencia: true,
        horariosSelecionados: {},
        gerenciarFrequencia: {
            acao: '',
            observacao: ''
        }
    }),
    mounted () {

        this.getFrequencia();

    },
    methods: {
        onSubmitFormFaltaJustificada() {

            this.$refs.gerenciarFrequencia.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                let payload = {
                    id: this.id, 
                    turma_id: this.turma_id, 
                    aluno_id: this.aluno_id,
                    horariosSelecionados: this.horariosSelecionados,
                    ...this.gerenciarFrequencia
                }
                
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/updateInLote`, payload, this.$store.getters.getHeaderAuth).then(response => {
                    

                    if(typeof response.data.error !== 'undefined'){

                        window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('close');       
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
            
        },
        openModalGerenciarFrequencia() {

            if(Object.keys(this.horariosSelecionados).length === 0) {
                window.eventBus.$emit('alert', {msg: 'É necessário selecionar, pelo menos, um horário.', type: 'warning'});
                return;
            }

            this.dialogGerenciarFrequencia = true;
        },
        selectHorario(horario, mesAno, dia) {

            if(this.horariosSelecionados[`${horario}-${dia}-${mesAno}`]) {
                Vue.delete(this.horariosSelecionados, `${horario}-${dia}-${mesAno}`);
            } else {
                Vue.set(this.horariosSelecionados, `${horario}-${dia}-${mesAno}`, true);
            }

            
        },
        getFrequencia(){

            let payload = {};
            
            if(this.id) {

                payload['id'] = this.id;

            } else {

                payload['contexto'] = null;

                if(this.tipo_ensino == 1 || this.tipo_ensino == 2 || this.tipo_ensino == 5){
                    payload['contexto'] = 'PRINCIPAL';
                }else if(this.tipo_ensino == 3){
                    payload['contexto'] = 'AEE';
                }else if(this.tipo_ensino == 4){
                    payload['contexto'] = 'ATIVIDADE_COMPLEMENTAR';
                }

                payload['turma_id'] = this.turma_id;
                payload['aluno_id'] = this.aluno_id;

            }
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/getFrequenciaByFiltros`, payload, this.$store.getters.getHeaderAuth).then(response => {
                

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});
                    this.$emit('close');

                }else{

                    this.frequencia = response.data;
                    this.loadingFrequencia = false;    
                   
                }

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        getTotalFaltasMes(mesIndex) {
            if (!this.frequencia || !this.frequencia.chamada) return 0;
            let total = 0;            
            

            Object.values(this.frequencia.chamada).forEach(dia => {
                let mes = dia[mesIndex];

                if (mes && mes.length) {
                    mes.forEach(horario => {
                        if (horario.v === 'f' || horario.v === 'fj' ) {
                            total++;
                        }
                    });
                }
            });

            return total;
        },
        getPercentualFrequenciaMes(mesIndex) {
            if (!this.frequencia || !this.frequencia.chamada) return 0;
            let totalAulas = 0;
            let totalFaltas = 0;

            Object.values(this.frequencia.chamada).forEach(dia => {
                let mes = dia[mesIndex];

                if (mes && mes.length) {
                    mes.forEach(horario => {
                        totalAulas++;

                        if (horario.v === 'f' || horario.v === 'fj' ) {
                            totalFaltas++;
                        }
                    });
                }
            });

            if (totalAulas === 0) return 0;

            let frequencia = ((totalAulas - totalFaltas) / totalAulas) * 100;

            return frequencia.toFixed(1);
        }
    
    },
    components:{  }
}
</script>
<style>
    .table-frequencia td, .table-frequencia th {
        border: 1px solid #ccc !important;
    }
    .hour-selected {
        background-color: #ccc;
    }
</style>